import React from 'react';
import {FlexBox} from "../ui/styled";
import {AI_SCORE_BAD, AI_SCORE_GOOD, AI_SCORE_PERFECT, AI_SCORE_VERY_BAD} from "../../styled/scoreColor";
import {useTranslation} from "react-i18next";
import styled from "styled-components";

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
`;
const MasterHeaderSection = styled(HeaderSection)`
    margin-bottom: 20px;
`;

const BarBox = styled.div`
  width: fit-content;
  position: relative;
`;
const Bar = styled.div`
  position: absolute;
  bottom: 2px;
  width: 100%;
  height: 4px;
  background-color: ${props => props.theme.color.green_100};
  opacity: 0.3;
`;
const HeaderText = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: ${props => props.theme.color.dark_100};
  font-weight: bold;
`;
const HeaderExplainText = styled.span`
  color: ${props => props.theme.color.font_7F_89};
  font-size: 12px;
  line-height: 17px;
  white-space: pre-wrap;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const ScoreSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const ScoreEmptyBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 20px;
  font-weight: bold;
  background-color: ${props => props.scoreColor};
  font-size: 12px;
  line-height: 17px;
  color: #fff;
  border-radius: 3px;
  margin-right: 10px;
`;

const MasterEmptyBox = styled.div`
  font-size: 12px;
  color: #fff;
  width: 28px;
  height: 20px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${_ => AI_SCORE_GOOD};
`;
const ScoreExplainText = styled.span`
  flex: 1;
  color: ${props => props.theme.color.dark_100};
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;
  white-space: pre-wrap;
`;

const MasterExplainText = styled(ScoreExplainText)`
    margin-left: 6px;
`;

const TeamLuckExplainText = styled(ScoreExplainText)`
    margin-left: 10px;
`;


const Explain = ({children}) => {
    return (
        <div>
            {children}
        </div>
    );
};

const AIScore = () => {
    const {t} = useTranslation()
    return (
        <div>
            <HeaderSection>
                <BarBox>
                    <HeaderText> {t("explain.aiScoreHeader")}</HeaderText>
                    <Bar/>
                </BarBox>
                <HeaderExplainText>{t('explain.aiScoreExplain')}</HeaderExplainText>
            </HeaderSection>
            <ScoreSection>
                <FlexBox>
                    <ScoreEmptyBox scoreColor={AI_SCORE_PERFECT}>100 +</ScoreEmptyBox>
                    <ScoreExplainText>{t('explain.perfect')}</ScoreExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <ScoreEmptyBox scoreColor={AI_SCORE_PERFECT}>75~100</ScoreEmptyBox>
                    <ScoreExplainText>{t('explain.veryGood')}</ScoreExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <ScoreEmptyBox scoreColor={AI_SCORE_GOOD}>50~74</ScoreEmptyBox>
                    <ScoreExplainText>{t('explain.good')}</ScoreExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <ScoreEmptyBox scoreColor={AI_SCORE_BAD}>25~49</ScoreEmptyBox>
                    <ScoreExplainText>{t('explain.bad')}</ScoreExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <ScoreEmptyBox scoreColor={AI_SCORE_VERY_BAD}>0~24</ScoreEmptyBox>
                    <ScoreExplainText>{t('explain.veryBad')}</ScoreExplainText>
                </FlexBox>
            </ScoreSection>
        </div>
    )
}

const TeamLuckImgBox = styled.div``;

const TeamLuck = () => {
    const {t} = useTranslation()

    return (
        <div>
            <HeaderSection>
                <BarBox>
                    <HeaderText>{t('explain.teamLuck.header')}</HeaderText>
                    <Bar/>
                </BarBox>
                <HeaderExplainText>{t('explain.teamLuck.explain')}</HeaderExplainText>
            </HeaderSection>
            <ScoreSection>
                <FlexBox>
                    <TeamLuckImgBox>
                        <img
                            src={`./images/icon_teamluck_godlike.gif`}
                            width={16}
                            height={16}
                            alt={''}
                        />
                    </TeamLuckImgBox>
                    <TeamLuckExplainText>{t('explain.teamLuck.godLike')}</TeamLuckExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <TeamLuckImgBox>
                        <img
                            src={`./images/icon_teamluck_solid.svg`}
                            width={16}
                            height={16}
                            alt={''}
                        />
                    </TeamLuckImgBox>
                    <TeamLuckExplainText>{t('explain.teamLuck.solid')}</TeamLuckExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <TeamLuckImgBox>
                        <img
                            src={`./images/icon_teamluck_balanced.svg`}
                            width={16}
                            height={16}
                            alt={''}
                        />
                    </TeamLuckImgBox>
                    <TeamLuckExplainText>{t('explain.teamLuck.balanced')}</TeamLuckExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <TeamLuckImgBox>
                        <img
                            src={`./images/icon_teamluck_messy.svg`}
                            width={16}
                            height={16}
                            alt={''}
                        />
                    </TeamLuckImgBox>
                    <TeamLuckExplainText>{t('explain.teamLuck.messy')}</TeamLuckExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <TeamLuckImgBox>
                        <img
                            src={`./images/icon_teamluck_doomed.gif`}
                            width={16}
                            height={16}
                            alt={''}
                        />
                    </TeamLuckImgBox>
                    <TeamLuckExplainText>{t('explain.teamLuck.doomed')}</TeamLuckExplainText>
                </FlexBox>
            </ScoreSection>
        </div>
    )
}

const Master = () => {
    const {t} = useTranslation()
    return (
        <div>
            <MasterHeaderSection>
                <BarBox>
                    <HeaderText> {t("explain.masterHeader")}</HeaderText>
                    <Bar/>
                </BarBox>
            </MasterHeaderSection>
            <ScoreSection>
                <FlexBox>
                    <MasterEmptyBox>1</MasterEmptyBox>
                    <MasterExplainText>{t('explain.master1')}</MasterExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <MasterEmptyBox>2</MasterEmptyBox>
                    <MasterExplainText>{t('explain.master2')}</MasterExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <MasterEmptyBox>3</MasterEmptyBox>
                    <MasterExplainText>{t('explain.master3')}</MasterExplainText>
                </FlexBox>
            </ScoreSection>
        </div>
    )
}

Explain.AIScore = AIScore
Explain.TeamLuck = TeamLuck
Explain.Master = Master

export default Explain;

